export default __webpack_public_path__ + "static/media/invoice-sample.d054da65.jpg";